import { Layout } from 'antd';
import MenuPrivate from "../MenuPrivate";
import Menu from "../Menu";
import Footer from "../Footer/Footer";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";

const privateRoutes: string[] = [
  "/rifas",
  "/boletos",
];

const publicRoutes: string[] = [
  "/",
  "/login",
];

const MyLayout = () => {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;

    if (user && publicRoutes.includes(pathname)) {
      navigate("/rifas");
      return;
    }

    if (!user && privateRoutes.includes(pathname)) {
      navigate("/");
      return;
    }
  }, [user, pathname, navigate, loading]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {
        user ? <MenuPrivate /> : <Menu />
      }
      <Layout.Content>
        <Outlet />
      </Layout.Content>
      {pathname === "/preguntas" ? <Footer /> : null}
    </Layout>
  );
};

export default MyLayout;